import { defineStore } from 'pinia'
import { ref } from 'vue'
import apiClient from '../lib/api'

export const useAdminsStore = defineStore('admins', () => {
  const admins = ref([])
  const loading = ref(false)

  async function fetchAll() {
    loading.value = true
    try {
      const res = await apiClient.get('/admins')
      admins.value = res.data
    } finally {
      loading.value = false
    }
  }

  async function create({ email, password, name, role }) {
    const res = await apiClient.post('/admins', { email, password, name, role })
    if (res.data.admin) admins.value.push(res.data.admin)
    return res.data
  }

  async function updatePassword(id, password) {
    const res = await apiClient.patch(`/admins/${id}/password`, { password })
    return res.data
  }

  async function remove(id) {
    await apiClient.delete(`/admins/${id}`)
    admins.value = admins.value.filter(a => a.id !== id)
  }

  return { admins, loading, fetchAll, create, updatePassword, remove }
})
